module.exports = {"noData":"No data available","tab.distribution":"Distribution in regions","tab.ownership":"Certificates of title"}